"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertWorkspaceUserGroup = void 0;
var sdk_model_1 = require("@gooddata/sdk-model");
exports.convertWorkspaceUserGroup = function (group) {
    var _a = group.content, name = _a.name, description = _a.description, id = _a.id, links = group.links;
    return {
        ref: sdk_model_1.uriRef(links.self),
        name: name,
        id: id,
        description: description,
    };
};
//# sourceMappingURL=UserGroupsConverter.js.map